import React, { memo } from 'react';
import HBBaseFormField, {
    HBBaseFormFieldProps,
    splitFieldProps
} from '../HBBaseFormField/HBBaseFormField';
import HBTimezoneInput from '../HBTimezoneInput/HBTimezoneInput';
import { HBTimezoneInputProps } from '../HBTimezoneInput/HBTimezoneInput.types';
import { TControlSize } from '../../tokens/types';

export interface HBTimezoneFieldProps
    extends HBBaseFormFieldProps,
        Omit<HBTimezoneInputProps, 'size' | 'width'> {
    size?: TControlSize;
}

const HBTimezoneField = ({ size = 'sm', ...props }: HBTimezoneFieldProps) => {
    const { fieldProps, inputProps } = splitFieldProps(props);

    return (
        <HBBaseFormField {...fieldProps} size={size}>
            <HBTimezoneInput {...inputProps} size={size} />
        </HBBaseFormField>
    );
};

export default memo(HBTimezoneField);
